export const bgHomeImages = [
  {
    title: "Landscaping & Lawn Care Vancouver — Award-Winning Service Since 1995",
    button: "Find Out More",
    image: require("./assets/img/bh-family-lawn-care-services-north-vancouver.jpg"),
    alt: "Child playing with a dog on a well-maintained lawn while BUR-HAN landscaping professionals work in the background",
  },
  {
    title: "Join Our Team and embark on a journey of growth and success.",
    button: "Apply Now",
    image: require("./assets/img/bh-commercial-landscaping-vancouver.jpg"),
    alt: "BUR-HAN Garden & Lawn Care team performing commercial landscaping services in Vancouver.",
  },
  {
    title:
      "The European Chafer Beetle is in your area. Contact us today for advice on avoiding damage to your lawn.",
    button: "Get a quote",
    image: require("./assets/img/bh-backyard-garden-lawn-design-vancouver.jpg"),
    alt: "Beautiful backyard lawn and flower garden designed by BUR-HAN Garden & Lawn Care in Vancouver.",
  },
];

export const reviews = [
 
  {
    comment:
    "Reliable, prompt to respond to any issues and questions, quality of work is excellent.",
    name: "Munira S.",
    rating: 5,
  },
  {
    comment:
    "We're very happy with the service provided by Bur-Han. Frances and Lee are always professional and address our questions and concerns in a timely manner. We've been using their service for many years and will continue to do so.",
    name: "Beverley L.",
    rating: 5,
  },
  {
    comment:
    "I have been using Bur-Han for my lawn for some time now. They are always so pleasant to deal with and I love the email notice of when they are coming and when they have finished each job. I would highly recommend them.",
    name: "Janice J.",
    rating: 5,
  },
  {
    comment:
    "The Associa BC Team very much appreciate the good service Bur-Han provides and as per the feedback from clients.",
    name: "Laszlo A.",
    rating: 5,
  },
  {
    comment:
    "Bur-Han is amazing. Not only do they keep our greenery in tip top shape, they are also big contributors to the North Shore community and beyond! Keep up the great work Bur-han.",
    name: "Griffins Boxing",
    rating: 5,
  },
  {
    comment:
      "Our small strata have been using Bur-Han for lawncare for four out of the past six seasons; we tried other providers twice and returned to Bur-Han both times. The Bur-Han crews are courteous, dependable and efficient. We have a no-hassle lawn at a reasonable price. Back-office support (Frances) runs like clockwork and typically resolves any query by the next day. Give Bur-Han a call...",
    name: "Herman G.",
    rating: 5,
  },
  {
    comment:
      "Cannot recommend them enough. Communication was fantastic and were responsive to all gardening and yard maintenance as they came up. Great people as well.",
    name: "Eric M.",
    rating: 5,
  },
  {
    comment:
      "Great company with very responsive and supportive management. Frances was very attentive, professional and great to deal with. I would have no reservations recommending them for lawn care & gardening.",
    name: "Winston M.",
    rating: 5,
  },
  {
    comment:
      "Thank you Henry! All of us at BUR-HAN would like to thank you for your continued trust in our lawn cutting and fertilization services!",
    name: "Henry T.",
    rating: 5,
  },
  {
    comment:
      "The crew were polite, friendly, professional and accommodating. They paid attention to detail, even down to taking out an area and redoing it because they felt it wasn’t right. I would give Aaron and crew the highest recommendation and referral. The company contact has been passed along to a friend needing work on a patio.",
    name: "Judi S.",
    rating: 5,
  },
  {
    comment:
      "Great work. Great team and great responses for information.Exceptional follow-up for any and all concerns. Professional and very courteous.We appreciate quotes for services are reasonable and for what is necessary not ongoing upsells. Highly recommended",
    name: "Eric L.",
    rating: 5,
  },
  {
    comment: "Reliable and excellent service.",
    name: "Christopher M.",
    rating: 5,
  },
  {
    comment:
      "I was in need of some short-notice landscaping at a very overgrown property. The BUR-HAN team was easy to communicate with, and they were able to get a crew out within my timeline. Vincent & Alexandra did an excellent job! The property looks so much better!",
    name: "Ryan P.",
    rating: 5,
  },
  {
    comment:
      "Very happy with the services provided. Email communication was great - nice to be able to get things done without having to return phone calls or miss a call. Good stuff - thanks!",
    name: "Martyn C.",
    rating: 5,
  },
  {
    comment:
      "Great company. Customer Service is very good. Answer e mails promptly. Always send you a reminder as to when they will be arriving and what service they will be doing. Highly recommend.",
    name: "Sally N.",
    rating: 5,
  },
  {
    comment:
      "I was recommended by a friend to use BUR-HAN Garden and Lawn Care for my lawn services; and was pleasantly surprised by their professionalism and excellent rates. Would highly recommend to other friends.",
    name: "Kelly M.",
    rating: 5,
  },
];

export const options = {
  loop: false,
  margin: 10,
  nav: true,
  dots: false,
  autoplay: true,
  smartSpeed: 700,
  responsive: {
    0: { items: 1 },
    600: { items: 2 },
    1000: { items: 3 },
    1400: { items: 5 }, // Show 5 on wide screens
  },
};

export const selectCity = [
  { value: "Vancouver", label: "Vancouver" },
  { value: "North Vancouver", label: "North Vancouver" },
  { value: "West Vancouver", label: "West Vancouver" },
  { value: "Burnaby", label: "Burnaby" },
  { value: "Richmond", label: "Richmond" },
  { value: "New Westminister", label: "New Westminister" },
  { value: "Coquitlam", label: "Coquitlam" },
  { value: "Port Coquitlam", label: "Port Coquitlam" },
  { value: "Port Moody", label: "Port Moody" },
  { value: "Maple Ridge", label: "Maple Ridge" },
  { value: "Delta", label: "Delta" },
  { value: "Surrey", label: "Surrey" },
  { value: "White Rock", label: "White Rock" },
];

export const servicesOption = [
  {
    value: "Landscape Maintenance",
    label: "Landscape Maintenance",
  },
  {
    value: "Residential Lawn Care",
    label: "Residential Lawn Care",
  },
  {
    value: "Hardscape Installs/Maintenance",
    label: "Hardscape Installs/Maintenance",
  },
  {
    value: " Softscape Installs/Maintenance",
    label: " Softscape Installs/Maintenance",
  },
  {
    value: "Designs and Modelling",
    label: "Designs and Modelling",
  },
  {
    value: "Snow Management",
    label: "Snow Management",
  },
];

export const hearaboutusOption = [
  { value: "Internet Search", label: "Internet Search" },
  { value: "Google", label: "Google" },
  { value: "Homestars", label: "Homestars" },
  { value: "Yelp", label: "Yelp" },
  { value: "Linkedin", label: "Linkedin" },
  { value: "Instagram", label: "Instagram" },
  { value: "Facebook", label: "Facebook" },
  { value: "Facebook Promo", label: "Facebook Promo" },
  { value: "Website", label: "Website" },
  { value: "Neighbour", label: "Neighbour" },
  { value: "Referral", label: "Referral" },
  { value: "Business Card", label: "Business Card" },
  { value: "Truck Sign", label: "Truck Sign" },
  { value: "Other", label: "Other" },
];

export const driverslicenseOption = [
  { value: "Class 5", label: "Class 5" },
  { value: "Class 7", label: "Class 7" },
  { value: "None", label: "None" },
];

export const styles = {
  menuList: (base) => ({
    ...base,

    "::-webkit-scrollbar": {
      width: "5px",
    },
    "::-webkit-scrollbar-track": {
      background: "yellow",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#888",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  }),
};

export const photosDesign = [
  {
    src: require("./assets/img/projects/design/landscape-terrace-design.jpeg"),
    width: 4,
    height: 3,
    title: "Modern Landscaping with Tiered Gardens and Fire Pit",
    alt: "Modern landscaping design with tiered garden beds, outdoor seating, and fire pit in Vancouver.",
  },
  {
    src: require("./assets/img/projects/design/residential-landscape-plan.jpg"),
    width: 4,
    height: 3,
    title: "North Vancouver Landscaping Design Plan",
    alt: "Detailed garden plan with lawn, flower beds, and privacy hedges for North Vancouver landscaping project",
  },
  {
    src: require("./assets/img/projects/design/front-yard-landscape-plan.jpg"),
    width: 4,
    height: 3,
    title: "Front Yard Landscaping Services in Vancouver",
    alt: "Front yard landscaping plan with pathways, colorful flowers, and a variety of shrubs.",
  },
  {
    src: require("./assets/img/projects/design/flower-bed-garden-design.jpeg"),
    width: 4,
    height: 3,
    title: "Custom Landscaping Plan for Vancouver Gardens",
    alt: "Detailed landscaping plan featuring plant types and layout for a lush garden in Vancouver.",
  },
  {
    src: require("./assets/img/projects/design/boulevard-garden-design.jpg"),
    width: 4,
    height: 3,
    title: "Low-Maintenance Boulevard Garden Design",
    alt: "Boulevard garden design with mulch and rock beds for aesthetic appeal and low maintenance.",
  },
  {
    src: require("./assets/img/projects/design/modern-patio-design.jpeg"),
    width: 4,
    height: 3,
    title: "Modern Patio Landscaping",
    alt: "Modern patio design with wooden steps and natural stone pavers in a landscaped yard.",
  },
  {
    src: require("./assets/img/projects/design/flagstone-garden-walkway.jpg"),
    width: 4,
    height: 3,
    title: "Flagstone garden walkway with partial sun and shade planting zones",
    alt: "Flagstone Walkway with Sun and Shade Plant Zones.",
  },
  {
    src: require("./assets/img/projects/design/backyard-landscape-overview.jpg"),
    width: 4,
    height: 3,
    title: "Backyard Landscaping Design in Vancouver",
    alt: "Comprehensive backyard garden layout with diverse plants and rock beds for a modern look.",
  },
  {
    src: require("./assets/img/projects/design/privacy-garden-layout.jpeg"),
    width: 4,
    height: 3,
    title: "Privacy Landscaping Solutions in Vancouver",
    alt: "Privacy garden plan showcasing strategic plant placement for a serene backyard in Vancouver.",
  },
  {
    src: require("./assets/img/projects/design/garden-irrigation-design.jpg"),
    width: 4,
    height: 3,
    title: "Efficient Irrigation Landscaping Plan",
    alt: "Landscaping irrigation zones for efficient water usage and lush greenery.",
  },
  {
    src: require("./assets/img/projects/design/raised-garden-planting-plan.jpg"),
    width: 4,
    height: 3,
    title: "Raised Garden Bed Landscaping ",
    alt: "Raised garden planting plan featuring hydrangeas and sustainable plant selections.",
  },
  {
    src: require("./assets/img/projects/design/backyard-garden-design.jpeg"),
    width: 4,
    height: 3,
    title: "Expert Landscaping Design with Hydrangeas",
    alt: "Professional landscaping design with vibrant hydrangeas and privacy fencing in Vancouver.",
  },
];

export const photosPavingStone = [
  {
    src: require("./assets/img/projects/pavingStone/paving-stone-driveway-north-vancouver.jpg"),
    width: 4,
    height: 3,
    title: "Elegant Paving Stone Driveway in North Vancouver",
    alt: "A wet paving stone driveway with a clean and elegant layout in North Vancouver",
  },
  {
    src: require("./assets/img/projects/pavingStone/custom-circular-paving-stone-patio.jpg"),
    width: 4,
    height: 3,
    title: "Beautiful Circular Paving Stone Patio Design",
    alt: "A circular paving stone patio surrounded by lush greenery and vibrant flowers",
  },
  {
    src: require("./assets/img/projects/pavingStone/landscaping-paving-stones-rock-garden.jpg"),
    width: 4,
    height: 3,
    title: "Rock Garden and Paving Stone Landscape Design",
    alt: "A modern landscaping design featuring paving stones and a rock garden with vibrant plants",
  },
  {
    src: require("./assets/img/projects/pavingStone/sidewalk-paving-stones-urban-setting.jpg"),
    width: 4,
    height: 3,
    title: "Durable Paving Stone Sidewalk Design",
    alt: "A sidewalk made of clean paving stones in a busy urban area",
  },
  {
    src: require("./assets/img/projects/pavingStone/stepping-stone-pathway-landscape-rocks.jpg"),
    width: 4,
    height: 3,
    title: "Stepping Stone Pathway for Residential Landscaping",
    alt: "A charming stepping stone pathway surrounded by large landscape rocks and greenery",
  },
  {
    src: require("./assets/img/projects/pavingStone/paving-stone-driveway-elegant-design.jpg"),
    width: 4,
    height: 3,
    title: "Spacious and Stylish Paving Stone Driveway",
    alt: "A spacious paving stone driveway in a suburban area with a clean and uniform design",
  },
  {
    src: require("./assets/img/projects/pavingStone/modern-outdoor-paving-stone-patio.jpeg"),
    width: 4,
    height: 3,
    title: "Contemporary Paving Stone Patio Design",
    alt: "A modern outdoor patio area with square paving stones and stylish furniture",
  },
  {
    src: require("./assets/img/projects/pavingStone/front-yard-paving-stone-walkway.jpeg"),
    width: 4,
    height: 3,
    title: "Paving Stone Walkway for a Cozy Front Yard",
    alt: "A paved walkway leading to a cozy front yard with lush plants and garden beds",
  },
  {
    src: require("./assets/img/projects/pavingStone/covered-patio-paving-stones.jpeg"),
    width: 4,
    height: 3,
    title: "Covered patio with paving stones",
    alt: "A covered patio with sleek paving stones and clean design in a landscaped backyard",
  },
  {
    src: require("./assets/img/projects/pavingStone/backyard-patio-paving-stones-and-garden-beds.jpeg"),
    width: 4,
    height: 3,
    title: "Backyard Paving Stone Patio with Garden Beds",
    alt: "A backyard patio area with well-laid paving stones and adjacent garden beds",
  },
  {
    src: require("./assets/img/projects/pavingStone/high-quality-paving-stone-driveway-vancouver.jpg"),
    width: 4,
    height: 3,
    title:
      "Paving Stone Driveway Design in Vancouver - Elegant Landscaping Solutions",
    alt: "Elegant paving stone driveway design in Vancouver with scenic views",
  },
  {
    src: require("./assets/img/projects/pavingStone/modern-backyard-paving-vancouver.jpg"),
    width: 4,
    height: 3,
    title:
      "Modern Backyard Paving Stones for Stylish Patios - Vancouver Landscaping",
    alt: "Modern backyard paving stones for a stylish patio in Vancouver",
  },
];

export const photosRetainingWall = [
  {
    src: require("./assets/img/projects/retainingWall/retaining-wall-lighting.jpeg"),
    width: 4,
    height: 3,
    title: "Modern Retaining Wall with LED Lighting",
    alt: "Modern retaining wall with integrated LED lighting for evening ambiance",
  },
  {
    src: require("./assets/img/projects/retainingWall/retaining-wall-with-steps.jpg"),
    width: 4,
    height: 3,
    title: "Retaining Wall with Steps for Accessibility",
    alt: "Retaining wall featuring wide steps for access and style",
  },
  {
    src: require("./assets/img/projects/retainingWall/retaining-wall-garden-design.jpeg"),
    width: 4,
    height: 3,
    title: "Garden Retaining Wall Design",
    alt: "Retaining wall integrated with a lush garden landscape",
  },
  {
    src: require("./assets/img/projects/retainingWall/stone-retaining-wall-with-steps.jpeg"),
    width: 4,
    height: 3,
    title: "Stone Retaining Wall with Steps",
    alt: "Stone retaining wall with integrated steps, designed for functional and aesthetic landscaping.",
  },
  {
    src: require("./assets/img/projects/retainingWall/retaining-wall-landscaping-design.jpeg"),
    width: 4,
    height: 3,
    title: "Innovative Retaining Wall Landscaping Design",
    alt: "Landscaped retaining wall providing a tiered garden aesthetic",
  },
  {
    src: require("./assets/img/projects/retainingWall/tiered-retaining-wall-with-lawn.jpg"),
    width: 4,
    height: 3,
    title: "Tiered Retaining Wall for Multi-Level Gardens",
    alt: "Tiered retaining wall with lush green lawn and landscaping for a multi-level yard.",
  },
  {
    src: require("./assets/img/projects/retainingWall/corner-retaining-wall.jpeg"),
    width: 4,
    height: 3,
    title: "Corner retaining Wall for Garden Landscaping",
    alt: "Corner retaining wall for garden edge landscaping",
  },
  {
    src: require("./assets/img/projects/retainingWall/concrete-block-retaining-wall.jpg"),
    width: 4,
    height: 3,
    title: "Concrete Block Retaining Wall with Steps",
    alt: "Durable concrete block retaining wall with integrated steps",
  },
  {
    src: require("./assets/img/projects/retainingWall/illuminated-tiered-retaining-wall.jpeg"),
    width: 4,
    height: 3,
    title: "Illuminated Tiered Retaining Wall with Pergola Lighting",
    alt: "Illuminated tiered retaining wall with ambient lighting under a pergola at night",
  },
  {
    src: require("./assets/img/projects/retainingWall/retaining-wall-with-path.jpeg"),
    width: 4,
    height: 3,
    title: "Retaining Wall with Pathway Integration",
    alt: "Retaining wall with integrated stone path for functional landscaping",
  },
  {
    src: require("./assets/img/projects/retainingWall/wood-retaining-wall-garden-bed.jpeg"),
    width: 4,
    height: 3,
    title: "Wood Retaining Wall for Modern Gardens",
    alt: "Wooden retaining wall with garden bed, providing a natural and elegant landscaping solution.",
  },
  {
    src: require("./assets/img/projects/retainingWall/decorative-retaining-wall.jpg"),
    width: 4,
    height: 3,
    title: "Decorative Retaining Wall for Modern Landscapes",
    alt: "Decorative retaining wall with a sleek modern finish",
  },
];

export const photosTurfInstalls = [
  {
    src: require("./assets/img/projects/turfInstalls/front-yard-sod-installation.jpg"),
    width: 4,
    height: 3,
    title: "Front Yard Sod Installation",
    alt: "Freshly installed sod in a front yard, creating a lush green lawn.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/lawn-with-hedge-border.jpg"),
    width: 4,
    height: 3,
    title: "Lawn with Hedge Border | Professional Lawn Care Services",
    alt: "Well-maintained lawn with a neatly trimmed hedge border and a curved walkway.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/landscaped-lawn-garden-beds.jpg"),
    width: 4,
    height: 3,
    title: "Landscaped Lawn & Garden Beds | Enhance Your Outdoor Space",
    alt: "Landscaped lawn featuring vibrant garden beds along a clean sidewalk.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/backyard-sod-installation.jpg"),
    width: 4,
    height: 3,
    title: "Backyard Lawn Installation | Fresh Sod for a Healthy Lawn",
    alt: "Backyard with newly installed sod and lush greenery.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/backyard-lawn-sod-installation.jpg"),
    width: 4,
    height: 3,
    title: "Striped Lawn Mowing | Expert Lawn Maintenance Services",
    alt: "Front yard lawn with a freshly mowed striped pattern for a professional look.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/curved-lawn-design.jpg"),
    width: 4,
    height: 3,
    title: "Curved Lawn Design | Creative Landscaping Solutions",
    alt: "Beautiful curved lawn design with lush green grass and a neat sidewalk.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/fresh-sod-installation-residential-yard.jpg"),
    width: 4,
    height: 3,
    title: "Fresh Sod Installation | Professional Lawn Replacement Services",
    alt: "Fresh sod installation near a residential walkway for a lush green lawn.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/lawn-landscaping-with-shrubs.jpg"),
    width: 4,
    height: 3,
    title:
      "Lawn Landscaping Services | Enhance Your Yard with Expert Solutions",
    alt: "Beautifully landscaped lawn with neatly arranged shrubs and fresh sod.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/sod-lawn-tree-mulching.jpg"),
    width: 4,
    height: 3,
    title: "Tree Mulching & Sod Lawn | Complete Lawn Care Solutions",
    alt: "Freshly laid sod with tree mulching for a well-maintained lawn.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/side-yard-sod-installation.jpg"),
    width: 4,
    height: 3,
    title: "Side Yard Lawn Solutions | Professional Sod Installation Services",
    alt: "Side yard with newly installed sod and well-maintained landscaping.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/striped-lawn-mowing-pattern.jpg"),
    width: 4,
    height: 3,
    title: "Striped Lawn Installation",
    alt: "Freshly installed sod lawn with professional mowing stripes for a clean finish.",
  },
  {
    src: require("./assets/img/projects/turfInstalls/front-yard-sod-installation.jpg"),
    width: 4,
    height: 3,
    title: "Front Yard Sod Installation | Lush Green Lawn Solutions",
    alt: "Freshly installed sod in a front yard, creating a lush green lawn.",
  },
];
export const photosPlantings = [
  {
    src: require("./assets/img/projects/plantings/emerald-cedar-privacy-hedge.jpg"),
    width: 4,
    height: 3,
    title: "Emerald Cedar Privacy Hedge Installation",
    alt: "Emerald cedar trees planted in a neat row for privacy along a wooden fence.",
  },
  {
    src: require("./assets/img/projects/plantings/mulch-garden-bed-design.jpg"),
    width: 4,
    height: 3,
    title: "Mulched Garden Bed with Decorative Plants",
    alt: "Garden bed with fresh mulch and colorful plants bordered by decorative stones.",
  },
  {
    src: require("./assets/img/projects/plantings/retaining-wall-garden-bed.jpg"),
    width: 4,
    height: 3,
    title: "Retaining Wall Garden Bed Landscaping",
    alt: "A tiered garden bed with mulch and plants along a stone retaining wall.",
  },
  {
    src: require("./assets/img/projects/plantings/front-yard-garden-bed-installation.jpg"),
    width: 4,
    height: 3,
    title: "Front Yard Garden Bed Installation",
    alt: "Front yard landscaped with neatly arranged plants and fresh mulch.",
  },
  {
    src: require("./assets/img/projects/plantings/side-yard-garden-bed.jpg"),
    width: 4,
    height: 3,
    title: "Side Yard Garden Bed Installation",
    alt: "Side yard with a variety of plants in a well-maintained garden bed.",
  },
  {
    src: require("./assets/img/projects/plantings/backyard-garden-landscaping.jpg"),
    width: 4,
    height: 3,
    title: "Backyard Garden Landscaping",
    alt: "Beautifully landscaped backyard with diverse plant selection and mulch.",
  },
  {
    src: require("./assets/img/projects/plantings/garden-bed-with-flowers.jpg"),
    width: 4,
    height: 3,
    title: "Garden Bed with Colorful Flowers",
    alt: "Beautiful garden bed featuring vibrant pink flowers and ornamental grasses.",
  },
  {
    src: require("./assets/img/projects/plantings/shrub-landscaping-against-stone-wall.jpg"),
    width: 4,
    height: 3,
    title: "Shrub Landscaping Against Stone Wall",
    alt: "Well-maintained shrubs and greenery against a modern stone wall for a natural aesthetic.",
  },
  {
    src: require("./assets/img/projects/plantings/rock-garden-landscaping-design.jpg"),
    width: 4,
    height: 3,
    title: "Rock Garden Landscaping Design",
    alt: "Beautifully arranged rock garden with ornamental grasses and flowering shrubs.",
  },
  {
    src: require("./assets/img/projects/plantings/japanese-garden-landscaping.jpg"),
    width: 4,
    height: 3,
    title: "Japanese Garden Landscaping",
    alt: "Serene Japanese-style garden with rock arrangements, mulch, and a decorative stone pagoda.",
  },
  {
    src: require("./assets/img/projects/plantings/shaded-garden-bed.jpg"),
    width: 4,
    height: 3,
    title: "Shaded Garden Bed with White Flowers",
    alt: "A shaded garden bed featuring lush greenery and blooming white flowers.",
  },
  {
    src: require("./assets/img/projects/plantings/rock-border-garden-design.jpg"),
    width: 4,
    height: 3,
    title: "Rock Border Garden Design",
    alt: "Stylish rock border separating mulch and pebble areas for a clean landscape design.",
  },
];

export const photosOneTimeCleanups = [
  {
    src: require("./assets/img/projects/oneTimeCleanups/driveway-garden-cleanup-before-after.jpg"),
    width: 1.5,
    height: 1,
    title: "Driveway Garden Cleanup and Pruning - Before and After",
    alt: "Dense shrubbery beside a driveway pruned and cleaned for a polished, inviting look.",
  },
  {
    src: require("./assets/img/projects/oneTimeCleanups/mulch-installation-planting-bed-refresh-before-after.jpg"),
    width: 4,
    height: 3,
    title: "Mulch Installation and Plant Bed Refresh - Before and After",
    alt: "Dry plant bed transformed with mulch and fresh planting in a well-maintained garden.",
  },
  {
    src: require("./assets/img/projects/oneTimeCleanups/hedge-bed-cleanup-blooming-after.jpg"),
    width: 4,
    height: 3,
    title: " Hedge and Garden Bed Cleanup - Flowering Aftercare",
    alt: "Small hedges cleaned up with fresh mulch and blooming flowers after BUR-HAN landscaping service.",
  },
  {
    src: require("./assets/img/projects/oneTimeCleanups/backyard-brush-removal-transformation-west-vancouver.jpg"),
    width: 4,
    height: 3,
    title: "Backyard Brush Removal Transformation",
    alt: "Cluttered garden space transformed into a clean, pruned patio garden by BUR-HAN.",
  },
  {
    src: require("./assets/img/projects/oneTimeCleanups/pathway-brush-clearance-before-after-north-vancouver.jpg"),
    width: 4,
    height: 3,
    title: "Brush and Ivy Clearing from Pathway - Before and After",
    alt: "Dense vegetation covering a path before and clear, pruned walkway after BUR-HAN landscaping service.",
  },
  {
    src: require("./assets/img/projects/oneTimeCleanups/garden-stairs-cleanup-before-after-burhan.jpg"),
    width: 4,
    height: 3,
    title: "Garden Stair Cleanup - Before and After",
    alt: "Overgrown garden stairs before cleanup and neat, restored steps after landscaping by BUR-HAN."
  },
  {
    src: require("./assets/img/projects/oneTimeCleanups/backyard-slope-renovation-before-after.jpg"),
    width: 1.45,
    height: 1,
    title: "Sloped Backyard Landscaping - Before and After",
    alt: "Overgrown slope with uneven terrain transformed into a tiered and pruned space.",
  },
  {
    src: require("./assets/img/projects/oneTimeCleanups/front-yard-flowerbed-refresh-before-after.jpg"),
    width: 4,
    height: 3,
    title: "Front Yard Flowerbed Refresh - Before and After",
    alt: "Overgrown front yard flowerbed cleaned, mulched, and revitalized with new plants.",
  },
  
];